/**
 * Import the pages according to the alphabetical order
 * A-Z, ASC.
 * --- A comes first
 * --- Ab comes second
 * --- Ac comes third
 *
 * example:
 * -------- Dashboard
 * -------- Defi
 * -------- DefiAccounts
 * -------- DefiBalance
 * -------- DefiOverview
 * -------- DefiProtocols
 * -------- DefiTransactions
 * ... and so on
 */

import PageNotFound from './pages/PageNotFound';

import Assets from './pages/Assets';
import AssetsDetails from './pages/Assets/details';
import Clients from './pages/Clients';
import Dashboard from './pages/Dashboard';

import Home from './pages/Home';

/**
 * Imports of Defi Menu Pages
 * ...
 */
import DefiAccounts from './pages/Defi/accounts';
import DefiAccountDetails from './pages/Defi/details/details';
import DefiBalance from './pages/Defi/Balance';
import DefiOverview from './pages/Defi';
import DefiProtocols from './pages/Defi/protocols';
import DefiTransactions from './pages/Defi/transactions';

// End of Defi Menu page imports

/**
 * Imports of Exchange Menu Pages
 * ...
 */
import Exchanges from './pages/Exchanges/exchange';
import ExchangesOverview from './pages/Exchanges';
import ExchageTransactions from './pages/Exchanges/transactions';
import SpotBalances from './pages/Exchanges/spot_balances';
import MarginBalances from './pages/Exchanges/margin_balance';
import ExchangeTransactionDetails from './pages/Exchanges/details';
import ExchangeAccountDetails from './pages/Exchanges/details/details';

// End Of Exchange menu pages

import Login from './pages/Login';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Snapshots from './pages/Snapshots';

/**
 * Imports of Transaction Pages
 * ...
 */
import Transaction from './pages/Transaction';
import TransactionDetails from './pages/Transaction/details/details';
import ExchangeSingleTransactionDetails from './pages/Transaction/details/exchangeTranDetails';
// End Of  Transaction pages

/**
 * Imports of Hedge Fund Pages
 * ...
 */
import HedgeFund from './pages/HedgeFund';
import HedgeFundUser from './pages/HedgeFundUser';
import HedgeFundOverview from './pages/HedgeFund/overview';
import HedgeFundIndividual from './pages/HedgeFund/details/details';

/**
 * Imports of standard user Pages
 * ...
 */
import Standarduser from './pages/StandardUser';
import StandarduserOverview from './pages/StandardUser/overview';
import StandarduserIndividual from './pages/StandardUser/details/details';

/**
 * Imports of sync monitor Pages
 * ...
 */
import SyncMonitor from './pages/SyncMonitor';

/**
 * Imports of Home
 * ...
 */
import AdminHome from './pages/Admin/Home';

/**
 * Imports of Admin Assets
 * ...
 */
import AdminAssets from './pages/Admin/Assets';
/**
 * Imports of Admin Reports
 * ...
 */
import PrivacyAndPolicy from './pages/PrivacyAndPolicy/privacyAndPolicy';
import AdminReports from './pages/Admin/Reports';
import SubStandardUser from './pages/SubStandardUser';
import LinkedStandardTeam from './pages/LinkedStandardTeam';
import ForgotPassword from './pages/Login/ForgotPassword';
import TermsAndConditions from './pages/TermsPolicy/termsAndConditions';
import SubscriptionPlan from './pages/SubscriptionPlans';

const routes = [
  { path: '/assets', element: Assets, isPublic: false },
  { path: '/assets/chain/:id', element: AssetsDetails, isPublic: false },
  { path: '/clients', element: Clients, isPublic: false },
  { path: '/dashboard', element: Dashboard, isPublic: false },
  { path: '/defi/accounts', element: DefiAccounts, isPublic: false },
  { path: '/defi/:account/', element: DefiAccountDetails, isPublic: false },

  /**
   * this should be the default implementation for individual pages
   * discuss before making changes in this one
   * @param account is the wallet account
   * standard format =>  BASE_URL/:account/individual-page
   */
  { path: '/defi/:account/:path', element: DefiAccountDetails, isPublic: false },
  { path: '/defi/balances', element: DefiBalance, isPublic: false },
  { path: '/defi/overview', element: DefiOverview, isPublic: false },
  { path: '/defi/protocols', element: DefiProtocols, isPublic: false },
  { path: '/defi/transactions', element: DefiTransactions, isPublic: false },

  { path: '/exchanges/exchanges', element: Exchanges, isPublic: false },
  { path: '/exchanges/overview', element: ExchangesOverview, isPublic: false },
  { path: '/exchanges/spot-balance', element: SpotBalances, isPublic: false },
  {
    path: '/exchanges/margin-balance',
    element: MarginBalances,
    isPublic: false,
  },
  {
    path: '/exchanges/transactions',
    element: ExchageTransactions,
    isPublic: false,
  },
  {
    path: '/exchanges/transaction/:id',
    element: ExchangeTransactionDetails,
    isPublic: false,
  },
  { path: '/exchanges/:account/:path', element: ExchangeAccountDetails, isPublic: false },
  // { path: '/exchanges', element: Exchanges, isPublic: false },

  // { path: '/home', element: Home, isPublic: true },

  { path: '/home', element: DefiOverview, isPublic: true }, //using Defi overview till exchnages is not integrated
  { path: '/privacy-and-policy', element: PrivacyAndPolicy, isPublic: true },
  { path: '/login', element: Login, isPublic: true },
  { path: '/forgot-password', element: ForgotPassword, isPublic: true },
  { path: '/terms-and-conditions', element: TermsAndConditions, isPublic: true },
  // { path: '/logout', element: Login, isPublic: true },
  { path: '/reports', element: Reports, isPublic: false },
  { path: '/settings', element: Settings, isPublic: false },
  { path: '/snapshots', element: Snapshots, isPublic: false },

  { path: '/transaction', element: Transaction, isPublic: false },
  { path: '/transaction/:id', element: TransactionDetails, isPublic: false },

  // { path: '/', element: Home, isPublic: false },
  { path: '/', element: DefiOverview, isPublic: false }, //using Defi overview till exchnages is not integrated

  {
    path: '/admin/standard-users',
    element: Standarduser,
    isPublic: false,
  },
  {
    path: 'admin/standard-users/:accounts/:path',
    element: StandarduserIndividual,
    isPublic: false,
  },

  /**
   * Hedge fund user and admin routes
   */
  {
    path: '/hedgefund/users',
    element: HedgeFundUser,
    isPublic: false,
  },
];

export const adminRoutes = [
  {
    path: '/admin/hedge-funds',
    element: HedgeFund,
    isPublic: false,
  },

  {
    path: '/admin/hedge-fund/overview',
    element: HedgeFundOverview,
    isPublic: false,
  },
  {
    path: '/admin/hedge-fund/:accounts/:path',
    element: HedgeFundIndividual,
    isPublic: false,
  },

  {
    path: '/admin/standard-users',
    element: Standarduser,
    isPublic: false,
  },
  {
    path: 'admin/standard-users/:accounts/:path',
    element: StandarduserIndividual,
    isPublic: false,
  },
  {
    path: 'admin/standard/overview',
    element: StandarduserOverview,
    isPublic: false,
  },
  {
    path: '/admin/assets',
    element: AdminAssets,
    isPublic: false,
  },
  {
    path: '/admin/reports',
    element: AdminReports,
    isPublic: false,
  },
  {
    path: '/admin/:type/reports',
    element: AdminReports,
    isPublic: false,
  },

  {
    path: '/admin/:type/assets',
    element: AdminAssets,
    isPublic: false,
  },

  {
    path: '/admin/sync-monitor',
    element: SyncMonitor,
    isPublic: false,
  },
  {
    path: '/admin',
    element: AdminHome,
    isPublic: false,
  },
  { path: '/', element: AdminHome, isPublic: false },
  { path: '/settings', element: Settings, isPublic: false },
];

// New routes created for different user roles.
const standardUserRoutes = [
  { path: '/defi/accounts', element: DefiAccounts, isPublic: false },
  { path: '/defi/:account/', element: DefiAccountDetails, isPublic: false },
  { path: '/defi/:account/:path', element: DefiAccountDetails, isPublic: false },
  { path: '/defi/balances', element: DefiBalance, isPublic: false },
  { path: '/defi/overview', element: DefiOverview, isPublic: false },
  { path: '/defi/protocols', element: DefiProtocols, isPublic: false },
  { path: '/defi/transactions', element: DefiTransactions, isPublic: false },
  { path: '/exchanges/exchanges', element: Exchanges, isPublic: false },
  { path: '/exchanges/overview', element: ExchangesOverview, isPublic: false },
  { path: '/exchanges/spot-balance', element: SpotBalances, isPublic: false },
  { path: '/exchanges/margin-balance', element: MarginBalances, isPublic: false },
  { path: '/exchanges/transactions', element: ExchageTransactions, isPublic: false },
  {
    path: '/exchanges/transaction/:id',
    element: ExchangeSingleTransactionDetails,
    isPublic: false,
  },
  { path: '/exchanges/:account/:path', element: ExchangeAccountDetails, isPublic: false },
  { path: '/transaction/:id', element: TransactionDetails, isPublic: false },
  { path: '/snapshots', element: Snapshots, isPublic: false },
  { path: '/settings', element: Settings, isPublic: false },
  { path: '/', element: Home, isPublic: false },
  { path: '/home', element: Home, isPublic: false },
  { path: '/users', element: SubStandardUser, isPublic: false },
  { path: '/team', element: LinkedStandardTeam, isPublic: false },
  { path: '*', element: DefiOverview, isPublic: false },
];

const hedgeFundManagerRoutes = [
  { path: '/', element: Home, isPublic: false },
  { path: '/home', element: Home, isPublic: false },
  { path: '/defi/accounts', element: DefiAccounts, isPublic: false },
  { path: '/defi/:account/', element: DefiAccountDetails, isPublic: false },
  { path: '/defi/:account/:path', element: DefiAccountDetails, isPublic: false },
  { path: '/defi/balances', element: DefiBalance, isPublic: false },
  { path: '/defi/overview', element: DefiOverview, isPublic: false },
  { path: '/defi/protocols', element: DefiProtocols, isPublic: false },
  { path: '/defi/transactions', element: DefiTransactions, isPublic: false },
  { path: '/exchanges/exchanges', element: Exchanges, isPublic: false },
  { path: '/exchanges/overview', element: ExchangesOverview, isPublic: false },
  { path: '/exchanges/spot-balance', element: SpotBalances, isPublic: false },
  { path: '/exchanges/margin-balance', element: MarginBalances, isPublic: false },
  { path: '/exchanges/transactions', element: ExchageTransactions, isPublic: false },
  {
    path: '/exchanges/transaction/:id',
    element: ExchangeSingleTransactionDetails,
    isPublic: false,
  },
  { path: '/exchanges/:account/:path', element: ExchangeAccountDetails, isPublic: false },
  { path: '/transaction/:id', element: TransactionDetails, isPublic: false },
  { path: '/hedgefund/users', element: HedgeFundUser, isPublic: false },
  { path: '/snapshots', element: Snapshots, isPublic: false },
  { path: '/settings', element: Settings, isPublic: false },
  { path: '/*', element: DefiOverview, isPublic: false },
];

const hedgeFundUserRoutes = [
  { path: '/', element: DefiOverview, isPublic: false },
  { path: '/home', element: Home, isPublic: false },
  { path: '/defi/accounts', element: DefiAccounts, isPublic: false },
  { path: '/defi/:account/', element: DefiAccountDetails, isPublic: false },
  { path: '/defi/:account/:path', element: DefiAccountDetails, isPublic: false },
  { path: '/defi/balances', element: DefiBalance, isPublic: false },
  { path: '/defi/overview', element: DefiOverview, isPublic: false },
  { path: '/defi/protocols', element: DefiProtocols, isPublic: false },
  { path: '/defi/transactions', element: DefiTransactions, isPublic: false },
  { path: '/exchanges/exchanges', element: Exchanges, isPublic: false },
  { path: '/exchanges/overview', element: ExchangesOverview, isPublic: false },
  { path: '/exchanges/spot-balance', element: SpotBalances, isPublic: false },
  { path: '/exchanges/margin-balance', element: MarginBalances, isPublic: false },
  { path: '/exchanges/transactions', element: ExchageTransactions, isPublic: false },
  {
    path: '/exchanges/transaction/:id',
    element: ExchangeSingleTransactionDetails,
    isPublic: false,
  },
  { path: '/exchanges/:account/:path', element: ExchangeAccountDetails, isPublic: false },
  { path: '/snapshots', element: Snapshots, isPublic: false },
  { path: '/settings', element: Settings, isPublic: false },
  { path: '/*', element: DefiOverview, isPublic: false },
];

const superAdminRoutes = [
  {
    path: '/admin/hedge-funds',
    element: HedgeFund,
    isPublic: false,
  },
  {
    path: '/admin/standard-users',
    element: Standarduser,
    isPublic: false,
  },
  {
    path: '/admin/plans',
    element: SubscriptionPlan,
    isPublic: false,
  },
  {
    path: '/admin/sync-monitor',
    element: SyncMonitor,
    isPublic: false,
  },
  {
    path: '/admin',
    element: HedgeFund,
    isPublic: false,
  },
  { path: '/', element: HedgeFund, isPublic: false },
  { path: '/settings', element: Settings, isPublic: false },
  { path: '/*', element: HedgeFund, isPublic: false },
  { path: '/admin/*', element: HedgeFund, redirect: '/admin', isPublic: false },
];

export const publicRoutes = [
  { path: '/login', element: Login, isPublic: true },
  { path: '/forgot-password', element: ForgotPassword, isPublic: true },
  { path: '/privacy-and-policy', element: PrivacyAndPolicy, isPublic: true },
  // { path: '*', element: PageNotFound , isPublic: true }
  { path: '/terms-and-conditions', element: TermsAndConditions, isPublic: true },
];

export const routesByRole = {
  standard: standardUserRoutes,
  organization: hedgeFundManagerRoutes,
  // organization: {
  //   user: routes.concat(hedgeFundUserRoutes),
  //   manager: routes.concat(hedgeFundManagerRoutes),
  // },
  super_admin: superAdminRoutes,
};

export default routes;
